/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from "react";
import Table from "../../common/Table";
import Body from "../../components/Body";
import api from "../../config/api";
import moment from "moment";
import TableMenu from "../../components/TableMenu";
import { SplitButton } from "primereact/splitbutton";
import AppModal from "../../common/AppModal";
import ExpenseAddModel from "./ExpenseAddModel";
import PaySalaryModel from "./PaySalaryModel";
import ExpenseSettingsModel from "./ExpenseSettingsModel";
import useHeader from "../../hooks/useHeader";

import EditExpenseModel from "./EditExpenseModel";
import EditPaySalary from "./EditPaySalary";
import AppButton from "../../common/AppButton";
import { GiCog } from "react-icons/gi";
import { BiTrash } from "react-icons/bi";
import { toast } from "react-toastify";
import { getExpensesWithSalary } from "../../stores/ExpensesStore";
import { useQuery, useQueryClient } from "@tanstack/react-query";

const header = [
  { title: "Date", name: "date" },
  { title: "Category", name: "category", filter: "Select" },
  { title: "Amount ($)", name: "amount", numberFormat: true },
  { title: "Invoice", name: "invoice" },
  { title: "Comment", name: "comment" },
  { title: "", name: "" },
];

export default function ExpensesList() {
  const { setHeader } = useHeader();
  const [model, setModel] = useState({});
  const Expense = ExpenseAddModel();
  const PaySalary = PaySalaryModel();
  const ExpenseSetting = ExpenseSettingsModel();
  const EditExpense = EditExpenseModel();
  const EditPay = EditPaySalary();
  const queryClient = useQueryClient();

  const items = [
    {
      label: "Pay Salary",
      icon: "pi pi-user",
      command: () => {
        setModel({
          visible: true,

          model: (
            <PaySalary.Body
              onDone={() => {
                setModel({});
              }}
            />
          ),
        });
      },
    },
    {
      label: "Settings",
      icon: "pi pi-cog",
      command: () => {
        setModel({
          visible: true,
          body: <ExpenseSetting.Body onDone={() => {}} />,
          header: <ExpenseSetting.Header />,
        });
      },
    },
  ];
  useEffect(() => {
    setHeader("Expenses");
  }, []);

  const { data } = useQuery({
    queryFn: () => getExpensesWithSalary(),
    queryKey: ["expenseWithSalary"],
  });

  const deleteSalary = async (salary) => {
    const res = await api.put("salary", { _id: salary._id, isDeleted: true });
    if (!res.ok) return toast.error(res.originalError.message);
    queryClient.invalidateQueries(["salary"], ["expenseWithSalary"]);

    toast.success("Salary has been successfully deleted.");
  };
  const deleteExpense = async (expense) => {
    const res = await api.put("expenses", {
      _id: expense._id,
      isDeleted: true,
    });
    if (!res.ok) return toast.error(res.originalError.message);
    queryClient.invalidateQueries(["expenses"]);
    toast.success("Expense has been successfully deleted.");
  };
  const handleDelete = async (data) => {
    if (confirm("Are you sure want to delete ?") === false) return false;
    if (data?.category === "Salary") deleteSalary(data);
    else deleteExpense(data);
  };
  return (
    <Body noPadding>
      <TableMenu style={{ justifyContent: "flex-end" }}>
        <SplitButton
          icon="pi pi-plus"
          model={items}
          onClick={() => {
            setModel({
              visible: true,

              model: (
                <Expense.Body
                  onDone={() => {
                    setModel({});
                  }}
                />
              ),
            });
          }}
          className="p-mr-2"
        ></SplitButton>
      </TableMenu>
      <Table
        countNumber={false}
        sideButtonStyle={{ maxWidth: 100 }}
        countReverse
        header={header}
        data={
          data?.map((i) => {
            return {
              ...i,
              category:
                i.category === null ? " - " : i.category?.category || "Salary",
              date: moment(i.date).format("DD/MM/YYYY"),
              comment: i.employee
                ? `${i.employee.name} - ${i.comment}`
                : i.comment,
              commentX: i.comment,
            };
          }) || []
        }
        loading={!data}
        SideButtons={({ inv }) => {
          return (
            <div className="side-button">
              <AppButton
                className="text-primary"
                tooltip={`Edit ${
                  inv.category === "Salary" ? "Salary" : "Expense"
                }`}
                leftIcon={<GiCog />}
                onClick={() => {
                  if (inv.category !== "Salary") {
                    return setModel({
                      visible: true,
                      footer: <EditExpense.Footer />,
                      body: (
                        <EditExpense.Body
                          data={{
                            ...inv,
                            date: moment(inv.date, "DD/MM/YYYY").toDate(),
                          }}
                          onDone={() => {
                            setModel({});
                          }}
                        />
                      ),
                      header: <EditExpense.Header />,
                      bodyStyle: { overflow: "unset" },
                    });
                  }

                  return setModel({
                    visible: true,
                    footer: <EditPay.Footer />,
                    body: (
                      <EditPay.Body
                        data={inv}
                        onDone={() => {
                          setModel({});
                        }}
                      />
                    ),
                    header: <EditPay.Header />,
                  });
                }}
              />

              <AppButton
                className="text-primary"
                onClick={() => handleDelete(inv)}
                leftIcon={<BiTrash />}
              />
            </div>
          );
        }}
      />
      <AppModal {...model} onHide={() => setModel({})} />
    </Body>
  );
}
